const AGE_TITLE_CURRENT = "Piattaforma per adulti";
const AGE_TITLE_NEW = "Chat vocale pubblica riservata agli adulti";
const AGE_COPY_CURRENT = "Confermando qui sotto dichiari di avere almeno 18 anni e di accettare le regole di moderazione soft.";

function patchAgeGate(root = document) {
  const view = root.querySelector?.('[data-testid="registration-view"]');
  if (!view) return;

  const title = Array.from(view.querySelectorAll("h2")).find(
    (node) => node.textContent?.trim() === AGE_TITLE_CURRENT,
  );
  if (title) title.textContent = AGE_TITLE_NEW;

  const copy = Array.from(view.querySelectorAll("p")).find(
    (node) => node.textContent?.trim() === AGE_COPY_CURRENT,
  );
  if (copy && !copy.dataset.onboardingPatched) {
    copy.dataset.onboardingPatched = "true";
    copy.classList.add("ol-age-gate-copy");
    copy.innerHTML = [
      "<strong>L’accesso è consentito solo ai maggiorenni (18+).</strong>",
      "<span>You Voice è una chat pubblica di confronto tra adulti. Non è un sito pornografico né una piattaforma dedicata a contenuti sessuali.</span>",
      "<span>Potresti ascoltare opinioni forti, linguaggio offensivo, satira, provocazioni o critiche severe. La moderazione è soft, mentre restano vietati tutti i contenuti contrari alla legge.</span>",
    ].join("");
  }
}

export function startOnboardingVisualPatch() {
  patchAgeGate();
  const observer = new MutationObserver(() => patchAgeGate());
  observer.observe(document.documentElement, { childList: true, subtree: true });
  return () => observer.disconnect();
}
